module.exports = __webpack_public_path__ + "assets/like_icon.3253a245.svg";